import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import { getServiceNameByType } from '../../serviceOrders/serviceOrderUtils';
import { ServiceType } from '../commonServiceOrder.types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useId } from 'react';
import { OptionalLabel } from '../../../sharedComponents/OptionalLabel';

type ServiceTypeFilterProps = {
    value: ServiceType[];
    onChange: (filter: ServiceType[]) => void;
};
export const ServiceTypeFilter = ({ value: filter, onChange: onFilterChange }: ServiceTypeFilterProps) => {
    const intl = useIntl();
    const id = useId();

    const options = Object.values(ServiceType).map((serviceType) => ({
        id: serviceType,
        label: getServiceNameByType(serviceType),
    }));

    return (
        <>
            <OptionalLabel isOptional htmlFor={id}>
                <FormattedMessage id="outboundOrderBook.serviceOrders.export.filter.serviceName" />
            </OptionalLabel>
            <Multiselect
                id={id}
                inputAddon="rioglyph rioglyph-component-custom"
                placeholder={intl.formatMessage({
                    id: 'outboundPortal.serviceOrders.table.toolbar.filter.serviceCode.placeholder',
                })}
                options={options}
                value={filter}
                onChange={(selectedTypes: string[]) => onFilterChange(selectedTypes as ServiceType[])}
                multiline
            />
        </>
    );
};
